/**
 * This module allows an application consuming this library
 * to provide data to populate the drop downs inside the
 * generated blocks.
 * For example, the metadata creator use case creates
 * 'getNamespace' and 'getRelation' methods on this module by
 * calling it like so:
 * dataAccessMethods.defineMethod('namespace', ()=> {some code that provides namespaces});
 * dataAccessMethods.defineMethod('relation', (namespace)=> {some code that provides relations filtered by the selected namespace});
 *
 * The provided data must be in the form: [['Display Value 1','savedValue1'], ['Display Value 2','savedValue2']]
 */
const upperFirst = require('lodash/upperFirst');
const toExport = {
    defineMethod,
    getNamespaces: () => [['None Defined', '']],
    getRelations: () => [['None Defined', '']],
    getDefaultValueSelectors: () => [['None Defined', '']]
};

module.exports = toExport;

function defineMethod(valueType, getMethod) {
    let methodName = `get${upperFirst(valueType)}`;
    toExport[methodName] = getMethod;
}
